import DocumentManagement from './DocumentManagement'
export default DocumentManagement
